module.exports = __webpack_public_path__ + "img/adresse.5a16514e.png";